import { Box, Typography, CardContent, Card, Button, Container, Grid, Link } from '@mui/material';

interface InicioProps {
    setInicio: (value: boolean) => void;
}

export const Inicio: React.FC<InicioProps> = ({ setInicio }) => {
    return (
        <>
            <Container
                maxWidth="md"
                style={{ marginTop: '3rem', marginBottom: '2rem', paddingTop: '2rem' }}
            >
                {/* Header */}
                <Box textAlign="center" marginBottom={4} marginTop={10}>
                    <Typography variant="h3" gutterBottom>
                        Sistema de Venda de Internet via Bilhete
                    </Typography>
                    <Typography variant="body1">
                        Transforme seu Wi-Fi em uma fonte de renda de forma prática e eficiente.
                    </Typography>
                </Box>

                {/* Seção: O que é isso? */}
                <Card style={{ marginBottom: '2rem' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                            O que é isso?
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Um jeito simples de ganhar dinheiro com o Wi-Fi. Você vende acesso à internet usando bilhetes com senhas únicas.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Não precisa ser expert em tecnologia. Você controla quem usa e por quanto tempo, e só paga pela mensalidade do sistema quando realizar vendas.
                        </Typography>
                    </CardContent>
                </Card>

                {/* Seção: Como funciona? */}
                <Card style={{ marginBottom: '2rem' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                            Como funciona?
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Nosso sistema organiza sua internet para que ninguém use mais do que deveria. Cada pessoa compra um bilhete e recebe uma senha exclusiva para acessar o Wi-Fi.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Além disso, você pode acompanhar suas vendas com relatórios diários, semanais e mensais.
                        </Typography>
                    </CardContent>
                </Card>

                {/* Vantagens */}
                <Card style={{ marginBottom: '2rem' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                            Vantagens
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1" paragraph>
                                    ✅ Evita bagunça na rede.
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    ✅ Garante uma experiência boa para todos os usuários.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1" paragraph>
                                    ✅ Ajuda a organizar suas vendas e aumentar seu lucro.
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    ✅ Só paga a mensalidade se realizar vendas.
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                {/* Exemplo de lucro */}
                <Card style={{ marginBottom: '2rem' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                            Exemplo de Lucro
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Se você vende 10 bilhetes a R$ 5,00 cada, já ganha R$ 50,00.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Se vender 100 bilhetes, ganha R$ 500,00.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            E o melhor: você só paga a mensalidade do sistema se tiver vendas.
                        </Typography>
                    </CardContent>
                </Card>

                {/* Para quem é isso? */}
                <Card style={{ marginBottom: '2rem' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                            Para quem é isso?
                        </Typography>
                        <Typography variant="body1" paragraph>
                            ✅ Para quem já tem internet e quer ganhar mais.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            ✅ Para quem quer começar um negócio fácil e lucrativo.
                        </Typography>
                    </CardContent>
                </Card>

                {/* Chamada para ação */}
                <Box textAlign="center" marginTop={4}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        size="large" 
                        onClick={() => setInicio(false)}
                    >
                        Login
                    </Button>
                </Box>

                                {/* Políticas de Privacidade */}
                                <Box marginTop={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h4" gutterBottom>
                                Políticas de Privacidade
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Esta política de privacidade descreve como coletamos, usamos e protegemos suas 
                                informações ao utilizar nosso serviço. Ao acessar nosso site, você concorda com os 
                                termos descritos abaixo.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>1. Informações Coletadas:</strong> Podemos coletar informações pessoais 
                                como nome, e-mail, e dados de navegação, quando fornecidos voluntariamente pelos usuários.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>2. Uso das Informações:</strong> As informações coletadas são usadas para 
                                fornecer e melhorar nosso serviço, comunicar promoções ou atualizações, e atender 
                                às solicitações dos usuários.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>3. Compartilhamento de Informações:</strong> Não compartilhamos informações 
                                pessoais com terceiros, exceto quando necessário para cumprir obrigações legais ou com 
                                o consentimento explícito do usuário.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>4. Segurança:</strong> Adotamos medidas de segurança para proteger as informações 
                                contra acessos não autorizados, alterações ou divulgação.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>5. Alterações na Política:</strong> Reservamos o direito de alterar esta 
                                política de privacidade a qualquer momento. Recomendamos revisar esta página regularmente.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Para dúvidas ou mais informações, entre em contato conosco através do nosso suporte.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <Link href="/terms" color="primary">
                                    Termos de Uso
                                </Link>
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Rodapé */}
                <Box textAlign="center" marginTop={6} paddingTop={2} borderTop="1px solid #ddd">
                    <Typography variant="body2" color="textSecondary">
                        © 2025 Sistema de Venda de Internet via Bilhete. Todos os direitos reservados.
                    </Typography>
                </Box>
            </Container>
        </>
    );
};
